<template>
  <div>
    <div class="container-title">
      {{ $t('unloads.singular') }}
    </div>
    <b-card no-body>
      <b-card-body>
        <div class="row">
          <div class="col-12 col-md-6 col-xxl-4">
            <div class="row py-1">
              <div class="col-5 col-xxl-4 custom-label">
                {{ lodash.upperFirst($t('drivers.singular')) }}
              </div>
              <div class="col-1 custom-label">
                :
              </div>
              <div class="col-6 col-xl-7 custom-value">
                {{ driverLabel }}
              </div>
            </div>
            <div class="row py-1">
              <div class="col-5 col-xxl-4 custom-label">
                {{ lodash.upperFirst($t('vehicles.singular')) }}
              </div>
              <div class="col-1 custom-label">
                :
              </div>
              <div class="col-6 col-xl-7 custom-value">
                {{ vehicleLabel }}
              </div>
            </div>
          </div>
          <div class="col-12 col-md-6">
            <div class="row py-1">
              <div class="col-5 col-xxl-3 custom-label">
                {{ lodash.upperFirst($t('sale_notes.shows.date')) }}
              </div>
              <div class="col-1 custom-label">
                :
              </div>
              <div class="col-6 col-xxl custom-value">
                {{ date }}
              </div>
            </div>
            <div class="row py-1">
              <div class="col-5 col-xxl-3 custom-label">
                {{ lodash.upperFirst($t('factories.singular')) }}
              </div>
              <div class="col-1 custom-label">
                :
              </div>
              <div class="col-6 col-xxl custom-value">
                {{ buyerName }}
              </div>
            </div>
            <div class="row py-1">
              <div class="col-5 col-xxl-3 custom-label">
                {{ lodash.upperFirst($t('sale_notes.resumes.address')) }}
              </div>
              <div class="col-1 custom-label">
                :
              </div>
              <div class="col-6 col-xxl custom-value">
                {{ address }}
              </div>
            </div>
          </div>
          <div class="col-12">
            <div class="pt-4">
              <b-table-simple class="resume-table" responsive>
                <b-thead>
                  <b-tr>
                    <b-th rowspan="2">No</b-th>
                    <b-th rowspan="2">{{ lodash.startCase($t('products.singular')) }}</b-th>
                    <b-th colspan="2" style="text-align: center">{{ `${$t('purchase_orders.singular')}` }}</b-th>
                    <b-th colspan="2" style="text-align: center">{{ lodash.startCase($t('unloads.singular')) }}</b-th>
                    <b-th colspan="2" style="text-align: center">
                      {{ lodash.startCase($t('sale_notes.resumes.performance')) }}
                    </b-th>
                    <b-th rowspan="2">{{ lodash.startCase($t('sale_notes.resumes.quality')) }}</b-th>
                    <b-th rowspan="2" style="text-align: right">
                      {{ `${lodash.startCase($t('sale_notes.resumes.price'))} (/${$t('sale_notes.resumes.kg')})` }}
                    </b-th>
                    <b-th rowspan="2" style="text-align: right; width: 175px">
                      {{ lodash.startCase($t('sale_notes.resumes.amount')) }}
                    </b-th>
                  </b-tr>
                  <b-tr>
                    <b-th style="text-align: center">{{ lodash.startCase($t('sale_notes.resumes.size')) }}</b-th>
                    <b-th style="text-align: center">
                      {{ `${lodash.startCase($t('sale_notes.resumes.biomass'))} (${$t('sale_notes.resumes.kg')})` }}
                    </b-th>
                    <b-th style="text-align: center">{{ lodash.startCase($t('sale_notes.resumes.size')) }}</b-th>
                    <b-th style="text-align: center">
                      {{ `${lodash.startCase($t('sale_notes.resumes.biomass'))} (${$t('sale_notes.resumes.kg')})` }}
                    </b-th>
                    <b-th style="text-align: center">{{ lodash.startCase($t('sale_notes.resumes.size')) }}</b-th>
                    <b-th style="text-align: center">
                      {{ `${lodash.startCase($t('sale_notes.resumes.biomass'))} (${$t('sale_notes.resumes.kg')})` }}
                    </b-th>
                  </b-tr>
                </b-thead>
                <b-tbody>
                  <b-tr v-for="(item, index) in tableItems" :key="index">
                    <b-td
                        v-if="item._index_rowspan"
                        :rowspan="item._index_rowspan"
                        class="align-text-top"
                    >{{ item._index }}
                    </b-td>
                    <b-td
                        v-if="item.trip_rowspan"
                        :rowspan="item.trip_rowspan"
                        class="align-text-top"
                    >{{ $t(`product_categories.${item.product_name}`) }}
                    </b-td>
                    <b-td
                        v-if="item.trip_rowspan"
                        :rowspan="item.trip_rowspan"
                        class="align-text-top"
                        style="text-align: center">{{ decimalFormatter(item.trip_size) }}
                    </b-td>
                    <b-td
                        v-if="item.trip_rowspan"
                        :rowspan="item.trip_rowspan"
                        class="align-text-top"
                        style="text-align: center">{{ decimalFormatter(item.trip_quantity) }}
                    </b-td>
                    <b-td
                        v-if="item.sale_rowspan"
                        :rowspan="item.sale_rowspan"
                        class="align-text-top"
                        style="text-align: center">{{ decimalFormatter(item.sale_size) }}
                    </b-td>
                    <b-td
                        v-if="item.sale_rowspan"
                        :rowspan="item.sale_rowspan"
                        class="align-text-top"
                        style="text-align: center">{{ decimalFormatter(item.sale_quantity) }}
                    </b-td>
                    <b-td
                        class="align-text-top text-end"
                    >
                      <b-badge :variant="item.size_performance_badge_variant">
                        {{ percentageFormatter(item.size_performance) }}
                      </b-badge>
                    </b-td>
                    <b-td
                        v-if="item.quantity_performance_rowspan"
                        :rowspan="item.quantity_performance_rowspan"
                        class="align-text-top text-end"
                    >
                      <b-badge :variant="item.quantity_performance_badge_variant">
                        {{ percentageFormatter(item.quantity_performance) }}
                      </b-badge>
                    </b-td>
                    <b-td
                        v-if="item.sale_rowspan"
                        :rowspan="item.sale_rowspan"
                        class="align-text-top"
                    >{{ qualityFormatter(item.quality) }}
                    </b-td>
                    <b-td
                        v-if="item.sale_rowspan"
                        :rowspan="item.sale_rowspan"
                        class="align-text-top"
                        style="text-align: right"
                    >{{ currencyFormatter(item.unit_price) }}
                    </b-td>
                    <b-td
                        v-if="item.sale_rowspan"
                        :rowspan="item.sale_rowspan"
                        class="align-text-top"
                        style="text-align: right"
                    >{{ currencyFormatter(item.total_price) }}
                    </b-td>
                  </b-tr>
                </b-tbody>
              </b-table-simple>
            </div>
            <b-table-simple borderless class="resume-table resume-info">
              <b-tbody>
                <b-tr>
                  <b-th style="text-align: right">{{ lodash.upperFirst($t('sale_notes.resumes.sub_total')) }}:</b-th>
                  <b-th style="text-align: right;width: 175px">{{ $numeral(subTotal).format('$ 0,0.[00]') }}</b-th>
                </b-tr>
                <template v-if="showOtherFeeInUnload">
                  <b-tr>
                    <b-th style="text-align: right">{{ lodash.upperFirst($t('sale_notes.resumes.other_fee')) }}:</b-th>
                    <b-th style="text-align: right;width: 175px">{{ $numeral(otherFee).format('$ 0,0.[00]') }}</b-th>
                  </b-tr>
                  <b-tr>
                    <b-th style="text-align: right">{{
                        lodash.upperFirst($t('sale_notes.resumes.acceleration_fee'))
                      }}:
                    </b-th>
                    <b-th style="text-align: right;width: 175px">{{
                        $numeral(accelerationFee).format('$ 0,0.[00]')
                      }}
                    </b-th>
                  </b-tr>
                </template>
                <b-tr>
                  <b-th style="text-align: right">{{ lodash.upperFirst($t('sale_notes.resumes.PPh')) }}:</b-th>
                  <b-th style="text-align: right;width: 175px">{{ $numeral(pph).format('$ 0,0.[00]') }}</b-th>
                </b-tr>
                <b-tr>
                  <b-th :class="{'text-success': total > 0, 'text-danger': total < 0}" style="text-align: right">
                    {{ lodash.upperFirst($t('sale_notes.resumes.total')) }}:
                  </b-th>
                  <b-th :class="{'text-success': total > 0, 'text-danger': total < 0}"
                        style="text-align: right;width: 175px">{{ $numeral(total).format('$ 0,0.[00]') }}
                  </b-th>
                </b-tr>
              </b-tbody>
            </b-table-simple>
          </div>
        </div>
      </b-card-body>
    </b-card>
  </div>
</template>

<script>
import {round} from "lodash";

export default {
  name: 'unload',
  props: {
    activeTab: {type: String, default: 'admin'},
    purchaseOrders: {
      type: Array, default: function () {
        return {}
      }
    },
    value: {
      type: Object, default: function () {
        return []
      }
    },
  },
  data() {
    return {
      tableNumber: 0,
    }
  },
  computed: {
    showOtherFeeInUnload() {
      return this.value.type === 'harvest' || this.activeTab.toLowerCase() === 'admin';
    },
    driverLabel() {
      let {
        trip: {
          driver: {name, phone_number},
        },
      } = this.value

      return `${name} - ${phone_number}`
    },
    vehicleLabel() {
      let {
        trip: {
          vehicle: {type, license_plate},
        },
      } = this.value

      return `${this.lodash.startCase(this.$t(`vehicles.vehicle_types.${type}`))} - ${license_plate}`
    },
    factoryName() {
      return this.value?.customer?.name || '-'
    },
    date() {
      if (!this.value?.ordered_at) return '-'
      return this.$moment.utc(this.value.ordered_at).local().format('DD MMMM YYYY')
    },
    buyerName() {
      let {customer: {name}} = this.value
      return name
    },
    accelerationFee() {
      let accelerations = this.value?.sale_additional_items?.filter(({name}) => name.toLowerCase() === 'biaya percepatan')
      return -accelerations.reduce((carry, {total}) => carry + total, 0)
    },
    address() {
      let customerAddress = this.value
          .customer
          ?.addresses
          ?.find(({type}) => type === (this.value.is_unload_order ? 'processing' : 'brs'))
      let {region_full_name, address} = customerAddress ?? {}
      let result = address ?? ''

      if (region_full_name) result = `${region_full_name}, ${result}`

      return result
    },
    otherFee() {
      let results = this.value?.sale_additional_items?.filter(({name}) => !['pph 22', 'biaya percepatan'].includes(name.toLowerCase()))
      return -results.reduce((carry, {total}) => carry + total, 0)
    },
    pph() {
      let results = this.value?.sale_additional_items?.filter(({name}) => name.toLowerCase() === 'pph 22')
      return -results.reduce((carry, {total}) => carry + total, 0)
    },
    subTotal() {
      return this.value?.sale_items?.reduce((carry, {total_price}) => carry + total_price, 0) ?? 0
    },
    tableItems() {
      const saleItems = this.value?.sale_items ?? [];
      const getMinTripItemId = (saleItem) => {
        if (!saleItem?.trip_items?.length) return Number.POSITIVE_INFINITY;
        return saleItem.trip_items.reduce((minId, tripItem) => {
          const id = Number(tripItem?.id);
          if (!Number.isFinite(id)) return minId;
          return Math.min(minId, id);
        }, Number.POSITIVE_INFINITY);
      };
      const sortedSaleItems = [...saleItems].sort((a, b) => getMinTripItemId(a) - getMinTripItemId(b));
      let vm = this
      let formattedItems = [];
      let formattedIndex = 1;
      let partialTripItemIds = []
      for (let i = 0; i < sortedSaleItems.length; i++) {
        let item = sortedSaleItems[i];
        let sameTripItemCount = vm.value.sale_items.reduce((acc, curr) => acc + curr.trip_items.filter(tripItem => tripItem.id === item.trip_items[0].id).length, 0)
        item.is_merge_item = item.trip_items.length > 1
        item.is_partial_item = sameTripItemCount > 1
        item.is_single_item = !item.is_merge_item && !item.is_partial_item

        if (item.is_merge_item) {
          let totalTripItemQuantity = item.trip_items.reduce((acc, curr) => acc + curr.quantity, 0)

          item.trip_items.forEach((tripItem, index) => {
            let sizePerformance = round((tripItem.size - item.size) / tripItem.size, 4)
            let quantityPerformance = round((item.quantity - totalTripItemQuantity) / totalTripItemQuantity, 4)
            let saleRowspan = index === 0 ? item.trip_items.length : 0
            formattedItems.push({
              product_name: tripItem.product_code,
              service_fee: tripItem.purchase_order.service_fee,
              trip_size: tripItem.size,
              trip_quantity: tripItem.quantity,
              estimated_size: tripItem.size * 0.9,
              estimated_quantity: tripItem.quantity * 1.12,
              trip_rowspan: 1,
              sale_size: item.size,
              sale_quantity: item.quantity,
              quality: item.quality,
              unit_price: item.unit_price,
              total_price: item.total_price,
              size_performance: sizePerformance,
              size_performance_badge_variant: sizePerformance >= 0.05 ? 'success' : 'danger',
              quantity_performance: quantityPerformance,
              quantity_performance_badge_variant: quantityPerformance >= 0.05 ? 'success' : 'danger',
              quantity_performance_rowspan: saleRowspan,
              sale_rowspan: saleRowspan,
              _index: formattedIndex,
              _index_rowspan: saleRowspan,
              _bs_table_accent_bg: i % 2 === 0 ? 'white' : '#f8fafc'
            })
            if (saleRowspan > 0) {
              formattedIndex++
            }
          })
        } else if (item.is_partial_item) {
          if (partialTripItemIds.includes(item.trip_items[0].id)) {
            continue
          }
          let tripItem = item.trip_items[0]
          let filteredSaleItems = this.value?.sale_items?.filter(saleItem => saleItem.trip_items[0].id === tripItem.id)
          let totalFilteredSaleItemsQuantity = filteredSaleItems.reduce((acc, curr) => acc + curr.quantity, 0)
          let tripRowspan = filteredSaleItems.length
          let quantityPerformance = round((totalFilteredSaleItemsQuantity - tripItem.quantity) / tripItem.quantity, 4)
          partialTripItemIds.push(tripItem.id)

          filteredSaleItems.forEach((saleItem, index) => {
            let sizePerformance = round((tripItem.size - saleItem.size) / tripItem.size, 4)
            formattedItems.push({
              product_name: tripItem.product_code,
              service_fee: tripItem.purchase_order.service_fee,
              trip_size: tripItem.size,
              trip_quantity: tripItem.quantity,
              estimated_size: tripItem.size * 0.9,
              estimated_quantity: tripItem.quantity * 1.12,
              trip_rowspan: index === 0 ? tripRowspan : 0,
              sale_size: saleItem.size,
              sale_quantity: saleItem.quantity,
              quality: saleItem.quality,
              unit_price: saleItem.unit_price,
              total_price: saleItem.total_price,
              size_performance: sizePerformance,
              size_performance_badge_variant: sizePerformance >= 0.05 ? 'success' : 'danger',
              quantity_performance: quantityPerformance,
              quantity_performance_badge_variant: quantityPerformance >= 0.05 ? 'success' : 'danger',
              quantity_performance_rowspan: index === 0 ? tripRowspan : 0,
              sale_rowspan: 1,
              _index: formattedIndex,
              _index_rowspan: index === 0 ? tripRowspan : 0,
              _bs_table_accent_bg: i % 2 === 0 ? 'white' : '#f8fafc'
            })
          })
          formattedIndex++
        } else if (item.is_single_item) {
          let tripItem = item.trip_items[0]
          let sizePerformance = round((tripItem.size - item.size) / tripItem.size, 4)
          let quantityPerformance = round((item.quantity - tripItem.quantity) / tripItem.quantity, 4)

          formattedItems.push({
            product_name: tripItem.product_code,
            service_fee: tripItem.purchase_order.service_fee,
            trip_size: tripItem.size,
            trip_quantity: tripItem.quantity,
            estimated_size: tripItem.size * 0.9,
            estimated_quantity: tripItem.quantity * 1.12,
            trip_rowspan: 1,
            sale_size: item.size,
            sale_quantity: item.quantity,
            quality: item.quality,
            unit_price: item.unit_price,
            total_price: item.total_price,
            size_performance: sizePerformance,
            size_performance_badge_variant: sizePerformance >= 0.05 ? 'success' : 'danger',
            quantity_performance: quantityPerformance,
            quantity_performance_badge_variant: quantityPerformance >= 0.05 ? 'success' : 'danger',
            quantity_performance_rowspan: 1,
            sale_rowspan: 1,
            _index: formattedIndex,
            _index_rowspan: 1,
            _bs_table_accent_bg: i % 2 === 0 ? 'white' : '#f8fafc'
          })
          formattedIndex++
        }
      }

      return formattedItems
    },
    total() {
      if (this.value.type === 'harvest' || this.activeTab.toLowerCase() === 'admin') return this.value?.total ?? 0
      return this.subTotal - this.pph
    },
    totalBiomass() {
      return this.value?.trip_item_total_quantity || 0
    },
    totalPrice() {
      return this.value?.trip_item_total || 0
    }
  },
  methods: {
    currencyFormatter(value) {
      return this.$numeral(value).format('$ 0,0.[00]')
    },
    decimalFormatter(value) {
      return this.$numeral(value).format('0,0.[00]')
    },
    percentageFormatter(value) {
      return `${this.$numeral(value).format('0,0.[00]%')}`
    },
    qualityFormatter(quality) {
      return ['fresh', 'merah'].includes(quality) ? this.lodash.upperFirst(quality) : this.lodash.upperCase(quality)
    },
  }
}
</script>

<style lang="scss" scoped>
::v-deep {
  .badge {
    font: 400 12px/14px Inter;
    &.badge-success {
      background-color: #DCFCE7;
      color: #15803D;
    }
    &.badge-danger {
      background-color: #FEE2E2;
      color: #EF4444;
    }
  }
}

.resume-table {
  th, td {
    vertical-align: middle;
  }
}

.resume-info {
  margin: 0;

  th, td {
    padding: 4px 8px;
  }
}
</style>
